"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselViewStyled = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _const = require("@dbi-tools/ui-kit/lib/const");

var _carousel = require("../../carousel/carousel.styled");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .slick-slider {\n    .slick-control {\n      top: calc(50% - 2px);\n\n      ", "\n\n      &:first-child {\n        left: -10px;\n      }\n\n      &:last-child {\n        right: -10px;\n      }\n    }\n\n    .slick-list {\n      .slick-track {\n        .slick-slide {\n          & > div {\n            height: 100%;\n            display: flex;\n            align-items: center;\n\n            & > div {\n              height: unset;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  ", " {\n    .slick-slider {\n      .slick-control {\n        display: block !important;\n\n        &:first-child {\n          left: 5px;\n        }\n\n        &:last-child {\n          right: 5px;\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CarouselViewStyled = (0, _uiKit.styled)('div')(_templateObject(), _carousel.CarouselDefaultArrowStyles, _const.GridBreakpointsMediaDown.md);
exports.CarouselViewStyled = CarouselViewStyled;